import "./App.css";

//Import components
import Header from "./component/Header";
import Main from "./component/Main";

function App() {
  return (
    <>
      <Header />
      <Main />
    </>
  );
}

export default App;
